import { api } from '../../lib/api.ts';
import type { Role } from '../../store/auth.ts';

export interface OrgUserRow {
  id: string; email: string; name: string; nameDv?: string | null; role: Role;
  isOrgAdmin: boolean; isActive: boolean; createdAt: string;
  designationDv: string | null; designationEn: string | null;
}

export type OrgUserPatch = Partial<
  Pick<OrgUserRow, 'isActive' | 'role' | 'isOrgAdmin' | 'designationDv' | 'designationEn'>
>;

export interface MeUser {
  id: string; email: string; name: string; nameDv: string | null; role: Role;
  orgId: string | null; isOrgAdmin: boolean; orgName: string | null;
  designationDv: string | null; designationEn: string | null; notifyNinmun: boolean;
}

export const usersApi = {
  list: () => api.get<{ users: OrgUserRow[] }>('/users').then((r) => r.data.users),
  update: (id: string, patch: OrgUserPatch) =>
    api.patch<{ user: OrgUserRow }>(`/users/${id}`, patch).then((r) => r.data.user),
  me: () => api.get<{ user: MeUser }>('/users/me').then((r) => r.data.user),
  updateMe: (patch: { name?: string; notifyNinmun?: boolean }) =>
    api.patch('/users/me', patch).then((r) => r.data),
  changePassword: (current: string, next: string) => api.post('/users/me/password', { current, next }),
  resetPassword: (id: string) => api.post(`/users/${id}/reset-password`),
};
